import { gql } from "@apollo/client";

export const GET_ACTIVE_SIGNIFICANT_DEFICIENCIES = gql`
  query ActiveSignificantDeficiencies {
    getActiveSignificantDeficiencies {
      name
      value
    }
  }
`;

export const GET_ACTIVE_SYSTEMS = gql`
  query ActiveWaterSystemRatingsCount {
    getActiveWaterSystemRatingsCount {
      name
      value
    }
  }
`;

export const GET_UNDER_ENFORCEMENT = gql`
  query SystemsUnderEnforcement {
    getSystemsUnderEnforcement {
      name
      value
    }
  }
`;

//value1 = sigDefCnt, value2=minDefCnt, value3=enfActionCnt
export const GET_PREVIOUS_MONTH_DEFICIENCIES_ENFORCEMENTS = gql`
  query PreviousMonthDeficienciesEnforcements {
    getPreviousMonthDeficienciesEnforcements {
      name
      value1
      value2
      value3
    }
  }
`;

//value1 = sigDefCnt, value2=minDefCnt, value3=enfActionCnt
export const GET_PREVIOUS_YEAR_DEFICIENCIES_ENFORCEMENTS = gql`
  query PreviousYearDeficienciesEnforcements {
    getPreviousYearDeficienciesEnforcements {
      name
      value1
      value2
      value3
    }
  }
`;

export const GET_RESOLVED_SIGNICANT_DEFICIENCIES = gql`
  query ResolvedWithoutEnforcementCounts {
    getResolvedWithoutEnforcementCounts {
      name
      value
    }
  }
`;
